




import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { BRAC_LOGIN } from "../store/actions.names";
import { ACCESS_TOKEN } from "../store/getters.names";
@Component({ name: "PostAuthenticationBrac" })
export default class PostAuthenticationBrac extends Vue {
  hashData: any = {};
  @Action(BRAC_LOGIN) login: any;
  @Getter(ACCESS_TOKEN) token: string;

  @Watch("token")
  handleFinishAuth(val: string | null, oldVal: string | null) {
    if (val != null && val.length > 0) {
      this.$router.push(this.hashData.state ? this.hashData.state : "/");
    } else {
      this.$router.push("/login");
    }
  }

  mounted() {
    console.log(this.$route);
    
    this.login({
      code: this.$route?.query?.code,
    })
      .then((data: any) => {
        console.log(data);
      })
      .catch((e) => {
        // this.$router.push("/password-reset/init");
        console.log(e);
        console.log(this.$route?.query?.code);
      });
  }
}
